<template>
  <div
    class="facet"
    :class="{ 'is-disabled': props.terms.length === 0, 'is-active': open }"
  >
    <button
      class="facet-toggle is-reset"
      :class="[{ 'is-active': open }, props.color]"
      @click="open = !open"
    >
      <span>{{ props.label }}</span>
      <span
        v-if="activeCount"
        class="ml-[.5em] bg-primary px-[.5em] text-[13px] font-bold text-scheme-main"
        >{{ activeCount }}</span
      >
      <div class="facet-toggle-icon">
        <span v-if="open">⬆</span>
        <span v-else>⬇</span>
      </div>
    </button>
    <div v-if="open" class="facet-terms">
      <SearchFacetTerm
        v-for="term in termsSorted"
        :key="term.key"
        :term="term"
        :facet-id="props.facetKey"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {
  SearchFacet,
  SearchFacetTerm,
} from '~~/layers/legacy-search/app/types'
import { ref, computed } from 'vue'

const props = withDefaults(
  defineProps<{
    facetKey: SearchFacet['key']
    terms: SearchFacetTerm[]
    label: SearchFacet['label']
    color?: string
  }>(),
  {
    facetKey: '',
    terms: () => [],
    label: '',
    color: '',
  },
)

const open = ref(false)

const termsSorted = computed(() => {
  return [...props.terms].sort((a, b) => {
    return a.weight > b.weight ? 1 : -1
  })
})

const activeCount = computed(() => {
  return props.terms.filter((v) => v.active).length
})
</script>

<style lang="postcss">
.facet {
  @apply border-b border-solid border-border px-[2px] py-0;
  &.is-active {
    @apply bg-scheme-main-bis;
  }
  &.is-disabled {
    pointer-events: none;
    .facet-toggle,
    .facet-terms {
      opacity: 0.3;
    }
  }
  &.is-single {
    @apply pt-size-7;
  }
}
.facet-toggle {
  @apply flex w-full items-center px-0 py-size-7 text-size-6 font-bold;
  color: currentColor;
  .tag {
    margin-left: 0.5em;
  }
  &.is-grey {
    &:hover,
    &.is-active {
      @apply text-black;
    }
  }

  &.is-reset {
    @apply m-0 overflow-visible bg-transparent font-bold;
  }
}
button.facet-toggle {
  cursor: pointer;
  &:hover {
    @apply bg-scheme-main-bis;
  }
}
.facet-toggle-icon {
  margin-left: auto;
}
.facet-title {
  @apply pb-size-5;
}
.facet-terms {
  @apply pb-size-7;
  overflow: auto;
}
</style>
